import BaseStore from './BaseStore'

import SongNotFoundError from '../errors/SongNotFound';

class ErrorStore extends BaseStore {

	initialize() {
		this._hasError = false;
		this._error = null;
	}

	hasError() {
		return this._hasError;
	}

	getError() {
		return this._error;
	}

	emitNewError() {
		this.emit("DISPLAY_ERROR", this._error);
	}


	rehydrate(state) {
		if(state._hasError) {
			this._hasError = state._hasError;
			this._error = state._error;
		}

	}

	dehydrate() {
		return {
			_hasError: this._hasError,
			_error: this._error
		};
	}

	handleSongLoadError(err) {
		if(err.message == 'SongNotFound') {
			this.setError(404, "The song you have requested does not seem to exist.");
		} else {
			this.setError(503, "Something seemed to go wrong loading that song just now. You could try again and it might work. Who knows?!");
		}
	}

	handleSongSaveError(err) {
		this.setError(503, "Something seemed to go wrong loading that song just now. You could try again and it might work. Who knows?!");
	}

	setError(code, message) {
		this._error = {
			statusCode: code,
			message: message
		};
		this._hasError = true;
		this.emitNewError();
	}

}

ErrorStore.storeName = "ErrorStore";
ErrorStore.handlers = {
	'SONG_LOAD_ERROR': 'handleSongLoadError',
	'SONG_SAVE_ERROR': 'handleSongSaveError'
};

export default ErrorStore;